import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

//iconos
import { Create, Add, Payment } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { nPercent } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código', accessor: 'grupo', width: 130 },
  { Header: 'Nombre término', accessor: 'name' },
  { Header: 'Días extra', accessor: 'extra', width: 130 },
  { Header: '% Interés', accessor: 'interest_rate', width: 130, width: 130 },
  { Header: 'Estado', accessor: 'state', width: 130, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function PaymentTerm(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [paymentTerms, setPaymentTerms] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadPaymentTerms() {
    setDataLoading(true);
    let response = await wsGetAll('base/payment-term');
    setDataLoading(false);
    if (response.success) setPaymentTerms(response.data);
  }

  useEffect(() => {
    loadPaymentTerms();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadPaymentTerms} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_PAYMENT_TERMS_STORE}
              component={
                <CardIcon color="primary">
                  <Payment style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              {/* <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon> */<></>}
            </AllowedGuard>
            <CardIcon color="primary">
              <Payment style={{ color: 'white' }} />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Términos de pagos{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Términos-de-pago"
              defaultWidth={1000}
              columns={columns}
              data={paymentTerms.map((paymentTerm, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_PAYMENT_TERMS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(paymentTerm)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_PAYMENT_TERMS_DELETED}>
                        <ButtonDelete
                          entity="base/payment-term"
                          id={paymentTerm.id}
                          reload={loadPaymentTerms}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  grupo: paymentTerm.GroupNum,
                  name: paymentTerm.PymntGroup,
                  extra: paymentTerm.ExtraDays,
                  interest_rate: nPercent(paymentTerm.interest_rate),
                  state: paymentTerm.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
